import { Component, inject, input, OnInit } from '@angular/core';

import { EcmMaterialModule } from '@ecm/material';
import { LinkService, TrackingData } from '@ecm/router';

import { DashboardCommercialViewModel } from '../../../business/model/home/dashboard/dashboard-commercial.view-models';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../services/tracking.service';
import { UrlService } from '../../../services/url.service';
import { ImageUtils } from '../../../utils/image.utils';

@Component({
    selector: 'push-commercial',
    templateUrl: './push-commercial.component.html',
    styleUrls: ['./push-commercial.component.scss'],
    standalone: true,
    imports: [EcmMaterialModule],
})
export class PushCommercialComponent implements OnInit {
    public trackingName!: string;
    public isDisabledEclairLink: boolean;

    protected readonly linkService = inject(LinkService);
    private readonly trackingService = inject(TrackingService);
    private readonly urlService = inject(UrlService);

    public readonly commercialPush = input.required<DashboardCommercialViewModel>();
    public readonly isMobile = input.required<boolean>();
    public readonly isSoshBrand = input.required<boolean>();

    public ngOnInit(): void {
        const push = this.commercialPush();
        if (push) {
            if (push.link) {
                push.href = this.linkService.getLinkSync(push.link);
            }
            this.trackingName = this.trackingService.getTrackNamePerCategorie(
                push.category,
                this.isMobile(),
                this.isSoshBrand(),
            );
            if (push.link) {
                this.isDisabledEclairLink = this.urlService.isDisabledEclairLink(push.link);
            }
        }
    }

    public openLink(commercialPush: DashboardCommercialViewModel) {
        this.linkService.openLink(
            commercialPush.link,
            Object.assign(new TrackingData(), {
                cappingTracking:
                    commercialPush.advTracker && commercialPush.advTracker.length > 0
                        ? {
                              advTracker: commercialPush.advTracker,
                              code: commercialPush.code,
                              cid: commercialPush.cid,
                          }
                        : null,
                tmsTracking: {
                    trackedPage: TrackedPage.dashboard,
                    trackingArea: this.commercialPush().trackingData.tmsTracking.trackingArea,
                    trackingName: this.trackingName,
                },
            }),
        );
    }

    public getImgFormat(imageurl: string) {
        return ImageUtils.transformUrl(imageurl, '100');
    }
}
